import { render, staticRenderFns } from "./OrderActivity.vue?vue&type=template&id=b2eb6b68&lang=pug"
import script from "./OrderActivity.vue?vue&type=script&lang=js"
export * from "./OrderActivity.vue?vue&type=script&lang=js"
import style0 from "./OrderActivity.vue?vue&type=style&index=0&id=b2eb6b68&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports